import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';

@Component({
    templateUrl: './capture-admin-faxable-patient-prescriber-reports.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportDetailsTemplateDirective]
})
export class CaptureAdminFaxablePatientPrescriberReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/faxable_patient_prescriber_reports`;
  reportsCountUrl = `${environment.captureApi.url}/faxable_patient_prescriber_reports/count`;

  filtersForm = this.formBuilder.group({
    processedDate: [null],
  });
}
